import { forwardRef } from 'react'
import { IconButtonProps } from './props.js'

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      label,
      icon,
      variant = 'standard',
      size = 'md',
      className = '',
      disabled,
      ...attrs
    },
    ref
  ) => {
    const sizeClasses: Record<string, string> = {
      sm: 'h-8 w-8',
      md: 'h-8 w-8',
      lg: 'h-10 w-10',
    }

    const baseClasses = [
      'inline-flex items-center justify-center',
      'rounded-md transition-colors interactive',
      'focus-visible:outline-2 focus-visible:outline-offset-2',
      'disabled:opacity-40 disabled:cursor-not-allowed',
    ]

    let variantClasses: string[] = []

    if (variant === 'standard') {
      variantClasses = ['text-on-surface-variant hover:text-on-surface hover:bg-surface-high']
    } else if (variant === 'filled') {
      variantClasses = ['bg-surface-highest text-on-surface-variant hover:text-on-surface hover:bg-surface-high']
    } else if (variant === 'tonal') {
      variantClasses = ['bg-surface-highest text-on-surface-variant hover:text-on-surface hover:bg-surface-high']
    } else if (variant === 'danger') {
      variantClasses = ['text-error hover:text-on-surface hover:bg-surface-high']
    }

    const finalClassName = [
      baseClasses.join(' '),
      sizeClasses[size],
      variantClasses.join(' '),
      className,
    ]
      .filter(Boolean)
      .join(' ')

    return (
      <button
        ref={ref}
        disabled={disabled}
        aria-label={label}
        className={finalClassName}
        {...attrs}
      >
        {icon}
      </button>
    )
  }
)

IconButton.displayName = 'IconButton'
